import axios from 'axios';
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { User } from '@/models/User';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

interface UserData {
    '@id': string;
    'id': number;
    'firstName': string;
    'lastName': string;
    'email': string;
    'address': string;
    'phoneNumber': string;
    'forms': string[];
    'organisations': string[];
    'isMe': boolean;
    'isOwner': boolean;
}

@Module({ namespaced: true })
class UserModule extends VuexModule {
    _all: User[] = [];

    get all(): User[] {
        return this._all;
    }

    @Mutation
    add(user: User) {
        const index = this._all.findIndex((u: User) => u.id === user.id);
        if (index === -1) {
            this._all.push(user);
        }
    }

    @Mutation
    set(user: User) {
        const index = this._all.findIndex((u: User) => u.id === user.id);
        if (index > -1) {
            this._all.splice(index, 1, user);
        }
    }

    @Mutation
    remove(user: User) {
        const index = this._all.findIndex((u: User) => u.id === user.id);
        if (index > -1) {
            this._all.splice(index, 1);
        }
    }

    @Action
    async init(): Promise<User[]> {
        try {
            const r = await axios({
                method: 'GET',
                url: '/api/users',
            });
            return r.data['hydra:member'].map((data: any) => {
                const user = new User(data);

                this.context.commit('add', user);

                return user;
            });
        } catch (e) {
            return e;
        }
    }

    @Action
    async create(data: UserData) {
        const r: any = await axios({
            method: 'POST',
            url: '/api/users',
            data,
        });

        if (r.data) {
            const user = new User(r.data);
            this.context.commit('add', user);
        }

        return r;
    }

    @Action
    async update(data: UserData) {
        const r: any = await axios({
            method: 'PUT',
            url: `/api/users/${data.id}`,
            data,
        });

        if (r.data) {
            const user = new User(r.data);
            this.context.commit('set', user);
        }

        return r;
    }

    @Action
    async delete(user: User) {
        const r: any = await axios({
            method: 'DELETE',
            url: `/api/users/${user.id}`,
        });

        if (r.status === 204) {
            this.context.commit('remove', user);
        }

        return r;
    }
}

export default UserModule;
